import { render, staticRenderFns } from "./CompanyPaymentsList.vue?vue&type=template&id=104d197e&"
import script from "./CompanyPaymentsList.vue?vue&type=script&lang=js&"
export * from "./CompanyPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports